import * as PIXI from 'pixi.js';

interface ISnapPoint {
  x: number;
  y: number;
}

// Highlight ring drawn over the corner the cursor is currently snapped to,
// so the user can clearly see the snap is active while drawing.
export function snapIndicatorModel(point: ISnapPoint, scale: number): PIXI.Graphics {
  const indicator = new PIXI.Graphics();
  const radius = 8 / scale;

  // Bright cyan with a dark outline so the snapped shared corner stands out
  // clearly against both the orange drawing line and the existing (blue) roofs.
  indicator.lineStyle(4 / scale, 0x0A1F2C, 1);
  indicator.beginFill(0x00E5FF, 0.85);
  indicator.drawCircle(point.x, point.y, radius);
  indicator.endFill();

  // Inner white dot for an extra-visible "locked on" marker.
  indicator.lineStyle(0);
  indicator.beginFill(0xFFFFFF, 1);
  indicator.drawCircle(point.x, point.y, radius / 3);
  indicator.endFill();

  indicator.zIndex = 100000;

  return indicator;
}
